<template lang="pug" v-if="countryName === 'United States' || countryName === 'Canada'">
    v-row(v-if="countryName === 'United States' || countryName === 'Canada'")
        v-col(cols='4')
            v-autocomplete(
                label='City'
                v-model="cityId"
                @change="changeCity"
                :items="cities"
                item-text="name"
                item-value="city_id"
                clearable
                required
                :rules="[rules.required]"
                :search-input.sync="citySearch"
            )
                template(v-slot:item="data")
                    template
                        v-list-item-content
                            v-list-item-title {{ data.item.name }}
                            v-list-item-subtitle {{ data.item.region_name }}

        v-col(cols='4')
            v-autocomplete(
                :label="countryName === 'United States' ? 'State' : 'Province'"
                v-model="regionId"
                @change="changeRegion"
                :items="regions"
                item-text="name"
                item-value="region_id"
                clearable
                required
                :rules="[rules.required]"
                :search-input.sync="regionSearch"
            )

        v-col(cols='4')
            v-autocomplete(
                label='Postal Code'
                v-model="postalCodeId"
                @change="changePostalCode"
                @blur="postalCodesLoading = false"
                :items="postalCodes"
                item-text="name"
                item-value="postal_code_id"
                clearable
                required
                :rules="[rules.required]"
                :no-data-text="!((!!this.postalCodeSearch && this.postalCodeSearch.length > 1) || this.regionId > 0 || this.cityId > 0) ? 'Continue typing to lookup' : 'No results'"
                :loading="postalCodesLoading"
                :search-input.sync="postalCodeSearch"
            )
                template(v-slot:item="data")
                    template
                        v-list-item-content
                            v-list-item-title {{ data.item.name }}
                            v-list-item-subtitle {{ data.item.region_name }}

    v-row(v-else-if="countryName === 'Australia' || countryName === 'Mexico' || countryName === 'New Zealand'")
        v-col(cols='6')
            v-text-field(
                label='City'
                v-model="city"
                @input="emitAddressCityRegionPostal"
                :rules="[rules.required]"
                clearable
                required
                validate-on-blur
            )

        v-col(cols='6')
            v-text-field(
                label='State'
                v-model="region"
                @input="emitAddressCityRegionPostal"
                :rules="[rules.required]"
                clearable
                required
                validate-on-blur
            )

        v-col(cols='6')
            v-text-field(
                label='Postal Code'
                v-model="postalCode"
                @input="emitAddressCityRegionPostal"
                :rules="[rules.required]"
                clearable
                required
                validate-on-blur
            )

    v-row(v-else-if="countryName === 'France' || countryName === 'Switzerland'")
        v-col(cols='6')
            v-text-field(
                label='Postal Code'
                v-model="postalCode"
                @input="emitAddressCityRegionPostal"
                :rules="[rules.required]"
                clearable
                required
                validate-on-blur
            )

        v-col(cols='6')
            v-text-field(
                label='City'
                v-model="city"
                @input="emitAddressCityRegionPostal"
                :rules="[rules.required]"
                clearable
                required
                validate-on-blur
            )

        v-col(cols='12' v-if="countryName === 'France'")
            v-text-field(
                label='Region'
                v-model="region"
                @input="emitAddressCityRegionPostal"
                :rules="[rules.required]"
                clearable
                required
                validate-on-blur
            )

        v-col(cols='12' v-if="countryName === 'Switzerland'")
            v-text-field(
                label='Canton'
                v-model="region"
                @input="emitAddressCityRegionPostal"
                :rules="[rules.required]"
                clearable
                required
                validate-on-blur
            )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Data
    import { 
        GetCities,
        GetPostalCodes,
        GetRegions,
    } from "@/data";

    export default Vue.extend({
        data() {
            return {
                citiesMap: {},
                cities: [],
                citySearch: null,
                city: null,
                cityId: null,
                postalCode: null,
                postalCodeId: null,
                region: null,
                regionId: null,
                regionSearch: null,
                postalCodesMap: {},
                postalCodes: [],
                postalCodesLoading: false,
                postalCodeSearch: null,
                regions: [],
                rules: {
                    required: v => !!v || 'Required.',
                }
            }
        },
        methods: {
            changeCity(cityId) {
                if (!cityId) {
                    this.cityId = null
                    this.city = null
                }

                if (cityId > 0) {
                    const city = this.citiesMap[cityId];
                    if (city?.city_id > 0) {
                        this.city = city.name;
                        this.regionId = city.region_id;
                        this.setRegionName(city.region_id);
                    }
                }

                this.getPostalCodes();

                this.$emit('update-address-city-region-postal', this.getAddressParams());
            },
            changePostalCode(postalCodeId) {
                if (!postalCodeId) {
                    this.postalCodeId = null
                    this.postalCode = null
                    this.postalCodeSearch = null
                }

                if (postalCodeId > 0) {
                    const postalCode = this.postalCodesMap[postalCodeId];
                    if (postalCode?.postal_code_id > 0) {
                        this.postalCode = postalCode.name;
                        this.regionId = postalCode.region_id;
                        this.setRegionName(postalCode.region_id);
                    }
                }
                
                this.getCities();

                this.$emit('update-address-city-region-postal', this.getAddressParams());
            },
            changeRegion(regionId) {
                if (!regionId) {
                    this.regionId = null;
                    this.region = null;
                } else {
                    this.setRegionName(regionId);
                }

                this.cityId = null;
                this.city = null;
                this.postalCodeId = null;
                this.postalCode = null;
                this.postalCodeSearch = null;

                this.getPostalCodes();
                this.getCities();

                this.$emit('update-address-city-region-postal', this.getAddressParams());
            },
            setRegionName(regionId) {
                if (!(regionId > 0) || !(this.regions?.length > 0)) {
                    return;
                }

                const region = this.regions.find((r) => r.region_id === regionId);
                if (region?.name?.length > 0) {
                    this.region = region.name;
                }
            },
            getCities() {
                if (!(this.countryName === 'United States' || this.countryName === 'Canada')) {
                    this.cities = [];
                    this.citiesMap = {};
                    this.cityId = null;
                    return;
                }

                const options = {
                    country_id: this.countryId,
                    postal_code_id: this.postalCodeId,
                    region_id: this.regionId,
                }

                this.isLoading = true;
                GetCities(options).then((response) => {
                    if (response?.Data?.cities?.length > 0) {
                        const ungroupedCities = response.Data.cities;
                        const groupedCities = [];
                        const citiesMap = {};
                        if (ungroupedCities?.length > 1) {
                            ungroupedCities.forEach(function (city, index) {
                                if ((index === 0) || (ungroupedCities[index - 1]?.region_id !== city?.region_id)) {
                                    groupedCities.push({header: city.region_name})
                                }
    
                                groupedCities.push(city);
    
                                citiesMap[city.city_id] = city;
                            });

                            this.cities = groupedCities;
                            this.citiesMap = citiesMap;
                        } else if (ungroupedCities?.length === 1) {
                            this.cities = ungroupedCities;
                            this.citiesMap[ungroupedCities[0].city_id] = ungroupedCities[0];
                            if (this.cityId !== ungroupedCities[0].city_id) {
                                this.cityId = ungroupedCities[0].city_id;
                                this.changeCity(this.cityId);
                            }
                        }
                    }
                    this.isLoading = false;
                });
            },
            getAddressParams() {
                const params = {
                    city:           this.city,         
                    city_id:        this.cityId,       
                    postal_code:    this.postalCode,   
                    postal_code_id: this.postalCodeId, 
                    region:         this.region,       
                    region_id:      this.regionId,
                }

                return params
            },
            // Emit after v-model applies; sync @input sees stale city/region/postal.
            emitAddressCityRegionPostal() {
                this.$nextTick(() => {
                    this.$emit('update-address-city-region-postal', this.getAddressParams());
                });
            },
            resetAddressFields() {
                this.city = null;
                this.cityId = null;
                this.postalCode = null;
                this.postalCodeId = null;
                this.region = null;
                this.regionId = null;
                this.citiesMap = {};
                this.cities = [];
                this.postalCodesMap = {};
                this.postalCodes = [];
                this.postalCodesLoading = false;
                this.postalCodeSearch = null;
                this.regions = [];
            },
            getPostalCodes() {
                if (!(this.countryName === 'United States' || this.countryName === 'Canada')) {
                    this.postalCodes = [];
                    this.postalCodesMap = {};
                    this.postalCodeId = null;
                    return
                }

                this.postalCodesLoading = true;

                // need to have 2 postal code characters for acceptable sql load time
                if (!(this.postalCodeSearch?.length > 1 || this.regionId > 0 || this.cityId > 0)) {
                    this.postalCodes = [];
                    this.postalCodesMap = {};
                    this.postalCodeId = null;
                    this.postalCodesLoading = false;
                    return
                }

                const options = {
                    city_id: this.cityId,
                    country_id: this.countryId,
                    name: null,
                    region_id: this.regionId,
                    group_by_region: true,
                }

                if (this.postalCodeSearch?.length > 0) {
                    options.name = this.postalCodeSearch?.toString();
                }

                this.isLoading = true;
                GetPostalCodes(options).then((response) => {
                    if (response?.Data?.postal_codes?.length > 0) {
                        const ungroupedPostalCodes = response.Data.postal_codes;
                        const groupedPostalCodes = [];
                        const postalCodesMap = {};
                        if (ungroupedPostalCodes?.length > 1) {
                            ungroupedPostalCodes.forEach(function (postalCode, index) {
                                if ((index === 0) || (ungroupedPostalCodes[index - 1]?.region_id !== postalCode?.region_id)) {
                                    groupedPostalCodes.push({header: postalCode.region_name})
                                }
    
                                groupedPostalCodes.push(postalCode);
    
                                postalCodesMap[postalCode.postal_code_id] = postalCode;
                            });

                            this.postalCodes = groupedPostalCodes;
                            this.postalCodesMap = postalCodesMap;
                        } else if (ungroupedPostalCodes?.length === 1) {
                            this.postalCodes = ungroupedPostalCodes;
                            this.postalCodesMap[ungroupedPostalCodes[0].postal_code_id] = ungroupedPostalCodes[0];
                            // can't set postalCodeId because creates circular loop issues with cities
                        }
                    }
                    this.postalCodesLoading = false;
                    this.isLoading = false;
                });
            },
            getRegions() {
                if (!(this.countryName === 'United States' || this.countryName === 'Canada')) {
                    return [];
                }

                const options = {
                    country_id: this.countryId,
                }

                this.isLoading = true;
                GetRegions(options).then((response) => {
                    if (response?.Data?.regions?.length > 0) {
                        this.regions = response.Data.regions;
                    }
                    this.isLoading = false;
                });
            },
            initAddress() {
                if (this.addressCity?.length > 0) {
                    this.city = this.addressCity
                }
                if (this.addressCityId > 0) {
                    this.cityId = this.addressCityId
                }
                if (this.addressPostalCode?.length > 0) {
                    this.postalCode = this.addressPostalCode
                }
                if (this.addressPostalCodeId > 0) {
                    this.postalCodeId = this.addressPostalCodeId
                }
                if (this.addressRegion?.length > 0) {
                    this.region = this.addressRegion
                }
                if (this.addressRegionId > 0) {
                    this.regionId = this.addressRegionId
                }
            },
        },
        computed: {
        },
        components: {
        },
        props: {
            addressCity:         String,
            addressCityId:       Number,
            countryId:           Number,
            countryName:         String,
            addressPostalCode:   String,
            addressPostalCodeId: Number,
            addressRegion:       String,
            addressRegionId:     Number,
        },
        created() {
            this.initAddress();
            this.getRegions();
            this.getCities();
            this.getPostalCodes();
            return;
        },
        watch: {
            countryId: {
                handler(next, old) {
                    if (!(old > 0) || !(next > 0) || next === old) {
                        return;
                    }
                    this.resetAddressFields();
                    // countryName may update in the same tick; defer so US/CA labels match.
                    this.$nextTick(() => {
                        if (this.countryName === 'United States' || this.countryName === 'Canada') {
                            this.getRegions();
                            this.getCities();
                            this.getPostalCodes();
                        }
                    });
                },
            },
            countryName: {
                immediate: true,
                handler (next, old) {
                    if (!!old && next !== old) {
                        this.resetAddressFields();

                        if (next === 'United States' || next === 'Canada') {
                            this.getRegions();
                            this.getCities();
                            this.getPostalCodes();
                        }


                    }
                }
            },
            citySearch (val) {
                this.city = val;
                this.$emit('update-address-city-region-postal', this.getAddressParams());
            },
            postalCodeSearch (val) {
                this.postalCode = val;
                this.$emit('update-address-city-region-postal', this.getAddressParams());
                this.getPostalCodes();
            },
            regionSearch (val) {
                this.region = val;
                this.$emit('update-address-city-region-postal', this.getAddressParams());
            },
        }
    });
</script>

<style lang="scss" scoped>
</style>